import React from 'react';

import { VideoTutorielViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { buildDto } from '../utils/mappers';
import { VideoFormValue } from '../utils/type';

import ModalEdition from './ModalEdition';

interface ModalCreateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalCreate({
  close,
  visible,
  refreshDashboard,
}: ModalCreateProps): React.ReactElement {
  const initials: VideoFormValue = {};
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: VideoFormValue) =>
      AdminFonctionnelControllerApi.createVideoTutorielUsingPOST(
        buildDto(values),
      ),
  );

  const { validate } = useValidateReferentielForm(
    (field: VideoTutorielViolationDtoFormFieldEnum, values: VideoFormValue) =>
      AdminFonctionnelControllerApi.validateCreateVideoTutorielFieldUsingPOST(
        field,
        buildDto(values),
      ),
    response => response.videoTutorielViolationsDto ?? [],
  );

  return (
    <ModalEdition
      close={close}
      visible={visible}
      title="Créer une vidéo"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
